<!-- begin:: Footer -->
<div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
	<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
		<div class="kt-footer__copyright">
			Copyright&nbsp;<a href="http://kaspontech.com" target="_blank" class="kt-link"><b class="footer-kaspon">
					Kaspon Techworks Private
					Limited </b></a>&nbsp;&copy;&nbsp;{{today | date:'yyyy'}}.&nbsp;
			All rights reserved.
		</div>
	</div>
</div>
<!-- end:: Footer -->
<style>
	/* .footer-kaspon {
		color: #fff;
	} */
</style>